export const PROFILE_BACKGROUND_COLORS = [
  "white",
  "black",
  "on_red",
  "magenta",
  "orange",
  "cyan",
  "on_cyan",
  "green",
  "on_green",
  "on_blue",
] as const;

export type ProfileBackgroundColor = (typeof PROFILE_BACKGROUND_COLORS)[number];

export const PROFILE_BACKGROUND_THEMES = [
  "animal",
  "musical",
  "arts",
  "fruits",
  "sporty",
  "none",
] as const;

export type ProfileBackgroundTheme = (typeof PROFILE_BACKGROUND_THEMES)[number];

export type ProfileBackgroundFillColors = {
  backgroundFillColor: string;
  svgFillColor: string;
};

export type ProfileBackground = {
  backgroundColor: ProfileBackgroundColor;
  backgroundTheme: ProfileBackgroundTheme;
};
